// @ts-nocheck
/* eslint-disable */ /* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */ import { ReactComponent as LogoGoogle } from '../../../assets/images/Logos/logo-google.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoGoogleIcon = /* @__PURE__ */ withLogoClass(LogoGoogle);
